import {autoinject} from 'aurelia-framework';

@autoinject()
export class ScrollToTopCustomAttribute {
  constructor(private element: Element) {

  }

  bind() {
    this.element.addEventListener('click', (event) => {
      this.onClick(event);
    }, {capture: false});
  }

  onClick(event) {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    return true;
  }
}
